import React from "react";
import { Box, Stack, Tooltip } from "@mui/material";
import styled from "styled-components";
import JobComponent from "src/components/pipeline-duration-job-component";
import TimeSplitter from "../utils/time-splitter";

const TaskContainer = styled(Box)`
    height: 100%;
    width: 270px;
    min-width: 270px;
    padding: 16px;
    margin-bottom: 16px !important;
    background-color: #4f4f4f;
    border: 2px solid #5e5e5e;
    border-radius: 8px;
    position: relative;
    white-space: nowrap;

    &:not(:last-child)::before {
        content: "";
        position: absolute;
        top: 25px;
        left: 100%;
        height: 1px;
        width: 20px;
        background: #797979;
        transform: translateY(-50%);
    }

    @media (max-width: 600px) {
        width: 100%;
        &:not(:last-child)::before {
            left: 50%;
            top: 100%;
            width: 1px;
            height: 20px;
            transform: translateX(-50%);
        }
    }
`;

const StageText = styled.p`
    font-size: 14px;
    margin: 2px;
    white-space: nowrap;
    overflow-x: hidden;
    text-overflow: ellipsis;
`;

const PipelineDurationCardsExpand = ({ data, durationMode }) => {
    if (!data || data.length === 0) return null;
    return (
        <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={2}
            mr={1}
            style={{ width: "98%", maxHeight: "85%", marginTop: "12px", overflowX: "auto" }}
        >
            {data.map((task) => (
                <TaskContainer key={task}>
                    <Stack direction="row" justifyContent="space-between" style={{ width: "100%" }}>
                        <Tooltip title={<p>Runs: {task.runs}</p>}>
                            <StageText style={{ fontWeight: "500", width: "164px" }}>
                                {task.stageName}
                            </StageText>
                        </Tooltip>
                        <StageText>
                            {durationMode === "overall"
                                ? TimeSplitter(task.avgDuration, "stage-duration")
                                : TimeSplitter(task.sumDuration, "stage-duration")}
                        </StageText>
                    </Stack>
                    {task.jobs
                        .sort((a, b) => b.avgDuration - a.avgDuration)
                        .map((job) => (
                            <JobComponent key={job} job={job} durationMode={durationMode} />
                        ))}
                </TaskContainer>
            ))}
        </Stack>
    );
};

export default PipelineDurationCardsExpand;
